var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.19667 19.0217 4.00067 18.5507 4 18V16C4 15.7167 4.096 15.4793 4.288 15.288C4.48 15.0967 4.71733 15.0007 5 15C5.28267 14.9993 5.52033 15.0953 5.713 15.288C5.90567 15.4807 6.00133 15.718 6 16V18H18V16C18 15.7167 18.096 15.4793 18.288 15.288C18.48 15.0967 18.7173 15.0007 19 15C19.2827 14.9993 19.5203 15.0953 19.713 15.288C19.9057 15.4807 20.0013 15.718 20 16V18C20 18.55 19.8043 19.021 19.413 19.413C19.0217 19.805 18.5507 20.0007 18 20H6ZM11 7.85L9.125 9.725C8.925 9.925 8.68767 10.021 8.413 10.013C8.13833 10.005 7.90067 9.90067 7.7 9.7C7.51667 9.5 7.42067 9.26667 7.412 9C7.40333 8.73334 7.49933 8.5 7.7 8.3L11.3 4.7C11.4 4.6 11.5083 4.52934 11.625 4.488C11.7417 4.44667 11.8667 4.42567 12 4.425C12.1333 4.42434 12.2583 4.44534 12.375 4.488C12.4917 4.53067 12.6 4.60134 12.7 4.7L16.3 8.3C16.5 8.5 16.596 8.73334 16.588 9C16.58 9.26667 16.484 9.5 16.3 9.7C16.1 9.9 15.8627 10.0043 15.588 10.013C15.3133 10.0217 15.0757 9.92567 14.875 9.725L13 7.85V15C13 15.2833 12.904 15.521 12.712 15.713C12.52 15.905 12.2827 16.0007 12 16C11.7173 15.9993 11.48 15.9033 11.288 15.712C11.096 15.5207 11 15.2833 11 15V7.85Z",
    fill: "#8D8D8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/image-upload-icon.94c8619d6b2eb049fe4f017d2190d615.svg";
export { ForwardRef as ReactComponent };